import styled from "styled-components";
import { theme } from "../../../../constants/StyledComponents";
import { StyledTableGoals } from "../SchedaCM/Goals/Goals.styled";

export const StyledAssignedGoalTable = styled(StyledTableGoals)`
  table-layout: fixed;

  td,
  th {
    overflow-wrap: break-word;
  }

  thead th {
    overflow: hidden;

    & > div {
      min-width: 0;
      overflow: hidden;
    }

    & > div > div {
      display: block;
      min-width: 0;
      max-width: 100%;
      overflow: hidden;
    }

    & span {
      display: block;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
`;

export const StyledResumeBody = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
  flex: 1;
  min-height: 0;
  box-sizing: border-box;
  padding: 20px 0px 20px 0px;

  & .padding-bottom {
    padding-bottom: 20px;
  }
`;

export const StyledProfileInformation = styled.div`
  width: 20%;
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;
  border-right: 1px solid ${theme.colors.purple_2};

  & > div:first-child > span:last-child {
    word-break: break-word;
    overflow-wrap: break-word;
  }

  & > div:last-child {
    overflow: scroll;
  }
`;

export const StyledProfileDetail = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;

  & > div:last-child {
    display: flex;
    flex-direction: column;
  }
`;

export const StyledWorkInformation = styled.div`
  overscroll-behavior: contain;
  display: flex;
  flex-direction: column;
  padding: 0 20px;
  width: 80%;
  gap: 20px;
  /* L'altezza viene dallo stretch del flex-row padre (StyledResumeBody),
     non dal viewport: così si adatta sia alla pagina Collaboratore
     sia ai pannelli laterali (Matrice del Potenziale, Calibration). */
  min-height: 0;
  overflow-y: auto;

  & > div:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.purple_2};
    padding-bottom: 20px;
  }
`;

export const StyledWorkInformationTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;
  position: relative;
  margin-bottom: 12px;

  & > .filter-buttons-container {
    position: absolute;
    right: 20px;
  }
`;

export const StyledWorkInformationBodyGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 12px;
  margin-top: 12px;
`;

export const StyledActualProjectBody = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
`;

export const StyledAssignedGoalBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const StyledWorkInformationBodyRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;

  & > div:first-child {
    width: 140px;
  }

  & > div:last-child {
    width: 100%;
  }
`;

export const StyledCollaboratorFeedbackBodyStar = styled.div`
  gap: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  text-align: center;
`;

export const StyledContainerCollaboratorFeedbackBodyStar = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
`;

export const StyledProgressPlanHeader = styled.div`
  display: flex;
  flex-direction: row;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 12px;

    &:first-child {
      border-right: 1px solid ${theme.colors.purple_2};
      padding-right: 20px;
      margin-right: 20px;
      min-width: 200px;

      & > span > span {
        height: 22px;
      }
    }

    &:last-child {
      width: 100%;

      & > span > span {
        height: 22px;
      }
    }
  }
`;

export const StyledProgressPlanBody = styled.div<{ $isEditable?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const StyledDevelopmentQuadrantBody = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  width: 160px;
  align-items: center;
  height: 110px;

  @media (max-width: ${({ theme }) => theme.breakpoints.LG}px) {
    width: auto;
  }
`;

export const StyledPercentageAchievementsGoalsBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: center;

  & > span > span {
    display: flex;
    justify-content: center;
  }
`;

export const StyledBtnEditContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 5px 0 43px 0;

  & > div {
    position: absolute;
    right: 0;
    display: flex;
    flex-direction: row;
    gap: 12px;
  }
`;

export const StyledBtnModifyContainer = styled.div`
  position: relative;
  width: 100%;
  padding: 20px 0;

  & > button {
    display: flex;
    float: right;
  }
`;

export const StyledContainerCards = styled.div`
  & > div {
    height: 20px;
    gap: 10px;
    margin-bottom: 10px;
  }
`;

export const StyledWorkInformationBody = styled.div<{
  withMarginTop?: boolean;
  withMarginBottom?: boolean;
}>`
  border: 1px solid ${theme.colors.purple_2};
  border-radius: ${theme.variables.border_radius_1};
  margin-top: ${(props) => (props.withMarginTop ? "12px" : "0")};
  margin-bottom: ${(props) => (props.withMarginBottom ? "20px" : "0")};
  padding: 20px;
`;
